/*
 * @Author: Zhouqi
 * @Date: 2025-12-10 10:20:56
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-09
 */
import dynamic from 'next/dynamic';

import ImageEnhanceSkeleton from '@/3.0/image-enhance/_components/image-enhance-skeleton';
import DelayedRender from '@/components/DelayRender';
import { withLayout } from '@/utils/withLayout';

const ImageEnhance = dynamic(() => import('@/3.0/image-enhance/entry'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <ImageEnhanceSkeleton />
    </DelayedRender>
  ),
});

const ImageEnhancePage: React.FC = () => {
  return <ImageEnhance />;
};

export default withLayout(ImageEnhancePage);
